<script setup>
import AppButton from '#/general/AppButton.vue'
import { useGA } from '#/useGA'
import { useRoute } from 'vue-router'
const { event } = useGA()
const route = useRoute()
const navigationEvent = (path, eventLabel) => {
  if (route.fullPath !== path) {
    event('navigation', { eventCategory: 'navigation', eventLabel: eventLabel })
  }
}
</script>

<template lang="pug">
.terms-selector
  .routerPageSize
    .terms--content
      .terms-selector--title Uns geht’s ums Bauen ohne Land – Ihnen auch?
      .terms-selector--description
        | Wir Raumpioniere treten an, um das Bauen ohne Land voranzubringen. Konkret wollen wir die bauliche Verdichtung mit Hilfe unseres Potenzialrechners allen Hauseigentümerinnen und -eigentümern im Land zugänglich machen.
        br
        | Um ein gemeinsames Grundverständnis über die wichtigsten Begriffe zum Thema zu schaffen, haben wir ein Glossar entwickelt. Gleichzeitig finden Sie in unserem Blog immer wieder spannende Beiträge rund ums Bauen ohne Land. Viel Vergnügen!
      .terms-selector--options
        .terms-selector--option
          .terms-selector--option-svg
            svg(width='160' height='201' viewBox='0 0 160 201' fill='none' xmlns='http://www.w3.org/2000/svg')
              g(clip-path='url(#clip0_8130_15432)')
                path(d='M1.52942 71.089V199.471H88.8828V80.6082H11.0605C5.79623 80.6082 1.5405 76.3417 1.5405 71.089C1.5405 65.8252 5.80732 61.5698 11.0605 61.5698H74.5862' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M81.7344 71.0889H11.4595' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M40.0083 121.367H17.0118V148.151H40.0083V121.367Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 94.5825H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 103.503H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 112.435H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M48.9298 121.367H77.257' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M48.9298 130.288H77.257' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M48.9298 139.219H77.257' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M48.9298 148.151H77.257' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 157.072H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 166.004H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 174.936H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9369 183.856H77.2571' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M116.999 107.725L156.974 157.05C159.28 159.898 158.847 164.076 155.999 166.381L150.702 170.68C147.853 172.985 143.675 172.553 141.37 169.705L101.395 120.38' fill='#1F47CD')
                path(d='M116.999 107.725L156.974 157.05C159.28 159.898 158.847 164.076 155.999 166.381L150.702 170.68C147.853 172.985 143.675 172.553 141.37 169.705L101.395 120.38' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M86.0279 111.087C104.139 107.878 116.216 90.5861 113.005 72.4649C109.793 54.3437 92.5075 42.2553 74.3968 45.4647C56.2861 48.6741 44.2082 65.966 47.42 84.0873C50.6319 102.209 67.9172 114.297 86.0279 111.087Z' fill='#5FEEBF')
                path(d='M116.8 48.6154C100.42 28.4024 70.7515 25.2995 50.5478 41.6893C30.3442 58.0792 27.2521 87.7449 43.6323 107.958C60.0124 128.171 89.6806 131.274 109.884 114.884C130.088 98.4942 133.18 68.8284 116.8 48.6154ZM101.195 104.168C86.91 115.759 65.9416 113.565 54.3492 99.2699C42.7678 84.9745 44.9511 63.9968 59.2366 52.4054C73.5221 40.8139 94.4905 43.0081 106.083 57.3035C117.664 71.5989 115.481 92.5766 101.195 104.168Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M136.937 78.2812H158.459' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M120.313 38.1545L135.529 22.9282' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M80.1719 21.5318V0' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M40.0416 38.1545L24.8141 22.9282' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_8130_15432
                  rect(width='160' height='201' fill='white')
          app-button.terms-selector--option-btn(label="Blog" to="/blogs" @click="navigationEvent('/blogs', 'Blogs')")
        .terms-selector--option
          .terms-selector--option-svg
            svg(width='160' height='201' viewBox='0 0 160 201' fill='none' xmlns='http://www.w3.org/2000/svg')
              g(clip-path='url(#clip0_8130_15414)')
                path(d='M42.2102 137.934H45.9891L30.4858 104.024H26.9507L11.4474 137.934H15.1819L19.2378 128.88H38.1543L42.2102 137.934ZM20.5344 125.966L28.6905 107.725L36.8467 125.966H20.5233H20.5344Z' fill='#22223C')
                path(d='M56.4059 186.018L78.8242 157.682V155.21H51.9399V158.313H74.0701L51.6075 186.638V189.109H79.4115V186.018H56.4059Z' fill='#22223C')
                path(d='M1.5293 71.089V199.471H88.8753V80.6082H11.0596C5.79575 80.6082 1.54038 76.3417 1.54038 71.089C1.54038 65.8252 5.80684 61.5698 11.0596 61.5698H74.5799' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M81.7276 71.0894H11.4585' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M116.99 107.725L156.961 157.05C159.266 159.898 158.834 164.076 155.986 166.381L150.689 170.68C147.841 172.985 143.663 172.553 141.358 169.705L101.387 120.38' fill='#1F47CD')
                path(d='M116.99 107.725L156.961 157.05C159.266 159.898 158.834 164.076 155.986 166.381L150.689 170.68C147.841 172.985 143.663 172.553 141.358 169.705L101.387 120.38' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M86.0207 111.098C104.13 107.889 116.207 90.5969 112.995 72.4756C109.784 54.3544 92.4997 42.266 74.3906 45.4754C56.2814 48.6849 44.2045 65.9768 47.4161 84.098C50.6276 102.219 67.9115 114.308 86.0207 111.098Z' fill='#5FEEBF')
                path(d='M116.79 48.6154C100.411 28.4024 70.7456 25.2995 50.5437 41.6893C30.3417 58.0792 27.2499 87.7449 43.6287 107.958C60.0075 128.171 89.6732 131.274 109.875 114.884C130.077 98.4942 133.169 68.8284 116.79 48.6154ZM101.187 104.168C86.9028 115.759 65.9362 113.565 54.3447 99.2699C42.7643 84.9745 44.9474 63.9968 59.2317 52.4053C73.5161 40.8139 94.4827 43.0081 106.074 57.3035C117.655 71.5989 115.471 92.5765 101.187 104.168Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M136.926 78.2812H158.446' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M120.303 38.1545L135.518 22.9282' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M80.165 21.5318V0' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M40.0382 38.1545L24.812 22.9282' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_8130_15414
                  rect(width='159.987' height='201' fill='white')
          app-button.terms-selector--option-btn(label="Glossar" @click="$emit('update:visible', true)")
</template>

<style lang="sass">
.terms-selector
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  .terms--content
    display: flex
    align-items: center
    flex-direction: column
    .terms-selector--title
      font-weight: 500
      line-height: 130%
      text-align: center
      color: #22223C
      max-width: 850px
      @media screen and (min-width: 1024px)
        margin-top: 130px
        font-size: 55px
      @media screen and (max-width: 1024px)
        margin-top: 50px
        font-size: 30px
    .terms-selector--description
      max-width: 850px
      font-weight: 400
      line-height: 150%
      text-align: center
      color: #22223C
      @media screen and (min-width: 1024px)
        margin-bottom: 40px
        margin-top: 70px
        font-size: 20px
      @media screen and (max-width: 1024px)
        margin-bottom: 50px
        margin-top: 30px
        font-size: 16px
    .terms-selector--options
      display: flex
      width: 100%
      max-width: 850px
      @media screen and (min-width: 1024px)
        justify-content: space-between
        margin-bottom: 135px
      @media screen and (max-width: 1024px)
        flex-direction: column
        grid-gap: 40px
        align-items: center
        margin-bottom: 70px
      .terms-selector--option
        width: 320px
        display: flex
        flex-direction: column
        align-items: center
        @media screen and (min-width: 1024px)
        @media screen and (max-width: 1024px)
        .terms-selector--option-svg
          margin-bottom: 50px
          @media screen and (min-width: 1024px)
          @media screen and (max-width: 1024px)
        .terms-selector--option-btn
          width: 100%
</style>
